import type { IAddress } from "@/data/model/Location";

import { logError } from "@/shared/logging/errors";
import { Ripple } from "@/shared/ui/Ripple";

import { trans } from "@/app/localization/Trans";
import { Popup } from "@/app/ui/Popup";

export class LocationAddressPopup {
    public static show(locationAddress: IAddress, googleMapsLocationLink: string | undefined, uniqueId?: string) {
        const parent = $(".app");
        if (uniqueId !== undefined) {
            if (parent.find(".popup." + uniqueId).length !== 0) return;
        }

        //dim background
        let dim = parent.find("> .dim.popupdim");
        if (dim.length === 0) {
            dim = $('<div class="dim popupdim" />').appendTo(parent);
        } else {
            dim.stop(true, false);
        }

        dim[0].offsetHeight;

        dim.addClass("shown");

        const msg = $('<div class="popup' + (uniqueId === undefined ? "" : " " + uniqueId) + '"/>').appendTo(parent);
        const header = $('<div class="head"/>').appendTo(msg);

        $("<div/> <div/>").appendTo(header);

        $('<div class="closer"><i class="fal fa-times"></i></div>')
            .appendTo(header)
            .click((e) => {
                LocationAddressPopup.close($(e.currentTarget).parent().parent());
                e.preventDefault();
            });

        const locationAddressStr =
            (locationAddress.street ?? "") + ", " + (locationAddress.zip ?? "") + " " + (locationAddress.city ?? "");
        const isGoogleMapsLocationLinkAvailable = googleMapsLocationLink != null && googleMapsLocationLink.length > 0;
        const confirmButtonText = isGoogleMapsLocationLinkAvailable
            ? trans.orderReceivedPopover.googleMapsLocation
            : trans.orderReceivedPopover.copyAddress;

        $("<div>" + locationAddressStr + "</div>").appendTo(msg);

        const buttonsContainer = $('<div class="btns" />').appendTo(msg);
        const confirmButton = $('<button class="btn confirm">' + confirmButtonText + "</button>").appendTo(
            buttonsContainer
        );

        Ripple.bind(
            confirmButton.click(async (e) => {
                e.preventDefault();
                if (isGoogleMapsLocationLinkAvailable) {
                    window.open(googleMapsLocationLink);
                } else {
                    try {
                        await navigator.clipboard.writeText(locationAddressStr);
                        confirmButton.text(trans.general.copied);
                        setTimeout(() => {
                            confirmButton.text(confirmButtonText);
                        }, 1300);
                    } catch (ex) {
                        logError(ex);
                        Popup.show(trans.pay.btnFailed);
                    }
                }
            })
        );

        msg[0].offsetHeight;
        msg.css("margin-top", (msg.height() + 60) / -2);
        msg.addClass("addtohomescreen");
        msg.addClass("shown");
    }

    private static close($popup: JQuery) {
        $popup.addClass("closing")[0].offsetHeight;
        const totalPopups = $(".app > .popup").length;

        $popup
            .removeClass("shown")
            .delay(600)
            .queue((e) => {
                $popup.remove();
                e();
            });

        //check if dim needs to be removed
        if (totalPopups <= 1) {
            const dim = $(".app > .dim.popupdim")
                .delay(250)
                .queue((c) => {
                    dim.removeClass("shown")
                        .delay(350)
                        .queue((a) => {
                            dim.remove();
                            a();
                        });

                    c();
                });
        }
    }
}
